import React from "react";
import { useTranslation } from "react-i18next";

import Card from "components/card/Card";
import Form from "components/form/Form";
import FormLayout from "components/form/FormLayout";
import Input from "components/form/input/Input";
import SelectNew from "components/select/SelectNew";
import { useAccountingReferenceGroups } from "hooks/useAccountingReferenceGroups/useAccountingReferenceGroups";

export type TAccountingReferenceFieldsState = {
  title: string;
  reference_number: string;
  /** Select value. "none" is converted to null before saving. */
  group: string;
};

type AccountingReferenceFieldsProps = {
  value: TAccountingReferenceFieldsState;
  onChange: (value: TAccountingReferenceFieldsState) => void;
};

export default function AccountingReferenceFields({ value, onChange }: AccountingReferenceFieldsProps) {
  const { t } = useTranslation();
  const accountingReferenceGroups = useAccountingReferenceGroups();

  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { id, value: inputValue } = event.target;
    onChange({ ...value, [id]: inputValue });
  }

  return (
    <Form>
      <Card>
        <Card.Section>
          <FormLayout>
            <FormLayout.Group>
              <Input
                value={value.title}
                label={t("Title")}
                id="title"
                onChange={handleInputChange}
                placeholder={t("Title")}
              />
              <Input
                value={value.reference_number}
                label={t("Reference Number")}
                id="reference_number"
                onChange={handleInputChange}
                placeholder={t("Reference Number")}
              />
              <SelectNew
                label={t("Group")}
                id="group"
                options={accountingReferenceGroups}
                value={value.group}
                onChange={group => onChange({ ...value, group })}
              />
            </FormLayout.Group>
          </FormLayout>
        </Card.Section>
      </Card>
    </Form>
  );
}
